import api from '..'

const Restart = (id: number | string) => {
  return api.post(`/courses/${id}/restart`).then(({ data }) => data)
}

export default Restart
